import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { Inset } from 'syf-component-library/ui/spacing';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { DATA_OBJECT, DATA_TYPE } from '../../../const/analytics';
import MainContext from '../../../Context';
import isDCHEligible from '../../../helpers/isDCHEligible';
import useApiMachine from '../../../hooks/machines/useApiMachine';
import usePaymentMethodMachine from '../../../hooks/machines/usePaymentMethodMachine';
import { t } from '../../../strings/i18n';
import DebitCardMessageBox from '../../atoms/DebitCardMessageBox';
import IntroHeading from '../../atoms/IntroHeading';
import PageLevelError from '../../atoms/PageLevelError';
import { PaymentModalWrapper } from '../../atoms/styled';
import { AsyncModalFooter } from '../../atoms/styled/AsyncModalFooter';
import PaymentMethodForm from '../../molecules/PaymentMethods/PaymentMethodForm/PaymentMethodForm';
export const AddPaymentMethod = () => {
    const { sendToMainMachine, featureFlags } = useContext(MainContext);
    const [apiMachine] = useApiMachine();
    const [paymentMethodMachine] = usePaymentMethodMachine();
    const [formErrorMessage, setFormErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { accountSummaryQueryResult: { data: { billing, product } } } = apiMachine.context;
    const isDebitOption = paymentMethodMachine.matches('addNewDebitCard') ||
        paymentMethodMachine.matches('addPaymentMethod.addNewDebitCard');
    const shouldShowDebitCardBanner = isDCHEligible(billing, product.type, featureFlags) && isDebitOption;
    const submit = () => {
        /*
         * Normally, the submit button would be nested as a child of the `<form />`.
         * But our UI has it outside of the form element so we have to use the native
         * machine API to send the submit event
         */
        paymentMethodMachine.context.form.send({
            type: 'SUBMIT'
        });
    };
    const handleCancel = () => {
        sendToMainMachine({
            type: 'GO_TO_PAYMENT_FLOW'
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(PaymentModalWrapper, Object.assign({ bottom: "xlarge", "data-cy": "add-payment-method-page", top: "large", vertical: "large" }, { children: [shouldShowDebitCardBanner && (_jsx(Inset, Object.assign({ bottom: "xlarge" }, { children: _jsx(DebitCardMessageBox, {}) }))), _jsx(IntroHeading, { children: t('addPaymentMethod.makePaymentModalInstruction') }), formErrorMessage && _jsx(PageLevelError, { errorMessage: formErrorMessage }), _jsx(Stack, { size: "xlarge" }), _jsx(PaymentMethodForm, { errorMessage: formErrorMessage, setFormErrorMessage: setFormErrorMessage, setIsSubmitting: setIsSubmitting })] })), _jsx(FooterContainer, { children: _jsx(AsyncModalFooter, { dataCy: "add-payment-method-footer", dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: "next", dataSecondaryObject: DATA_OBJECT.BUTTON, dataSecondaryReason: "cancel", dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: submit, handleSecondaryButton: handleCancel, isPrimaryLoading: isSubmitting, isSecondaryDisabled: isSubmitting, primaryText: t('button.next'), secondaryButtonType: "ghost", secondaryText: t('button.cancel') }) })] }));
};
